import { render, staticRenderFns } from "./download-attachment-btn.vue?vue&type=template&id=15c45660&"
import script from "./download-attachment-btn.vue?vue&type=script&lang=js&"
export * from "./download-attachment-btn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports